// extracted by mini-css-extract-plugin
export default {"overlay":"overlay-V2Ri7","closeButton":"closeButton-VWSM0","tootipbox":"tootipbox-JK7wR"};